<app-monthly-balance-chart [data]="data()" [startDate]="this.startDate()" [endDate]="this.endDate()" [loading]="resource.isLoading()"></app-monthly-balance-chart>
